import { Navigate } from "react-router-dom"
import React from "react"
import UserProfile from "../pages/Authentication/user-profile"

import RegistrationDetails from "pages/Ecommerce/EcommerceOrders/RegistrationDetails"
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index"

import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ContactsList from "pages/Contacts/ContactList/contacts-list"
import CMSList from "pages/Ecommerce/CMSList"
import CMSDetails from "pages/Ecommerce//EcommerceOrders/CMSDetails"
import Dashboard from "../pages/Dashboard/index"
import EmailContent from "pages/EmailContent/EmailContent"
import QAndAList from "pages/QAndA/QAndAList"
import AddQuestion from "pages/QAndA/AddQuestion"
import EditQAndA from "pages/QAndA/EditQ&A"

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  { path: "/registration-list", component: <EcommerceOrders /> },
  { path: `/registration-list/:id`, component: <RegistrationDetails /> },

  { path: "/user-list", component: <ContactsList /> },
  { path: "/cms-list", component: <CMSList /> },
  { path: "/cms-list/:id", component: <CMSDetails /> },
  { path: "/email-content", component: <EmailContent />},
  { path: "/q-n-a", component: <QAndAList />},
  { path: "q-n-a/add-new-question", component: <AddQuestion />},
  { path: "q-n-a/:id", component: <EditQAndA />},
  //Utility

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
]

export { authProtectedRoutes, publicRoutes }
